import { Events } from '../utils/constants';

export function languageEvent(language: string) {
  return new CustomEvent<string>(Events.LANGUAGE_CHANGED_EVENT, { detail: language });
}
